// The Help section (NAV-012): a searchable list of articles grouped like the app, and the article.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { HelpScreen } from "./help";

export const HELP_PATH = "/help";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-012", path: HELP_PATH, title: "Help", permission: "signed-in", component: HelpScreen }),
  defineRoute({ nav: "NAV-012", path: "/help/:article", title: "Help", permission: "signed-in", component: HelpScreen }),
];
